import React, { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { styled } from 'linaria/react';
import { Button } from '@shared/ui/molecules';
import { Text } from '@shared/ui/atoms';
import { baseColors, withTheme } from '@shared/lib/theme';
import shiningDiamond from '../assets/shining-diamond.webp';
const FlocktoryBanner: FC = () => <FlocktoryBannerWrapper>
    <ContentWrapper>
      <ImageWrapper>
        <Image src={shiningDiamond} alt="" width={56} height={56} />
      </ImageWrapper>
      <TextWrapper>
        <Text family="MTSCompact" weight="medium" size="pM" color={baseColors.neutral_50}>
          Для вас подарок
        </Text>
        <Text family="MTSCompact" weight="medium" size="pS" color={baseColors.neutral_50}>
          за совершенный платёж
        </Text>
      </TextWrapper>
    </ContentWrapper>
    <ButtonWrapper>
      <Link target="_blank" href="https://share.flocktory.com/exchange/login?ssid=6701&bid=14289">
        <Button variant="secondary" size={{
        desktop: '44',
        mobile: '32'
      }}>
          Забрать
        </Button>
      </Link>
    </ButtonWrapper>
  </FlocktoryBannerWrapper>;
export default FlocktoryBanner;
const FlocktoryBannerWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "FlocktoryBannerWrapper",
  class: "fjyfxa5",
  propsAsIs: false
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "ih70sd8",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c56tzvh",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t6het1d",
  propsAsIs: false
});
const ButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonWrapper",
  class: "b1hekfzo",
  propsAsIs: false
});

require("./FlocktoryBanner.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./FlocktoryBanner.tsx");